import { render, staticRenderFns } from "./ModalActivateCrlv.vue?vue&type=template&id=71962306&scoped=true&"
import script from "./ModalActivateCrlv.vue?vue&type=script&lang=js&"
export * from "./ModalActivateCrlv.vue?vue&type=script&lang=js&"
import style0 from "./ModalActivateCrlv.vue?vue&type=style&index=0&id=71962306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71962306",
  null
  
)

export default component.exports